import React, { useImperativeHandle, useState, useRef, useEffect } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Pager, Paging } from "devextreme-react/data-grid";
import 'devextreme-react/text-area';
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../utils/media-query";
import PuntoDiRaccoltaEditPanel, { PuntoDiRaccoltaEditPanelHandle } from "./PuntoDiRaccoltaEditPanel";

type Props = {
  onHidden?: () => void;
  onDataChanged?: () => void;
}

export type PuntoDiRaccoltaEditPopupHandle = {
  edit: (puntoDiRaccoltaId: string, title?: string) => void,
  new: () => void
}

type state = {
  puntoDiRaccoltaId?: string,
  visible: boolean
}

const PuntoDiRaccoltaEditPopup: React.ForwardRefRenderFunction<PuntoDiRaccoltaEditPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ puntoDiRaccoltaId: undefined, visible: false  });
  const [popupTitle, setPopupTitle] = useState<string>("Punto di raccolta");
  const { isXSmall, isSmall } = useScreenSize();
  const [fullscreen, setFullscreen] = useState(isXSmall || isSmall);
  const puntoDiRaccoltaEditPanelRef = useRef<PuntoDiRaccoltaEditPanelHandle>(null);

  function hide() {
    setState({ puntoDiRaccoltaId: undefined, visible: false });
    props.onHidden?.();
  }

  async function SaveAndClose() {
    if (await puntoDiRaccoltaEditPanelRef.current?.save()) {
       props.onDataChanged?.();
      hide();
    }
  }

  useImperativeHandle(ref, () => ({
    edit(puntoDiRaccoltaId, title) {
      setState({
        puntoDiRaccoltaId: puntoDiRaccoltaId,
        visible: true
      });
      if (title)
        setPopupTitle(title);
    },
    new() {
      setState({
        puntoDiRaccoltaId: undefined,
        visible: true
      });
    }
  }));

  return (
    <React.Fragment>
      {state.visible &&
      <Popup
        visible={true}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={true}
        fullScreen={fullscreen}
        showTitle={true}
        onHidden={hide}
        title={popupTitle}
        container=".dx-viewport"
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          //visible={!(isXSmall || isSmall)}  
          options={{
            icon: 'fullscreen',
            onClick: () => setFullscreen(!fullscreen),
          }}
        />
         <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={{
            text: 'Salva',
            type: 'default',
            stylingMode: 'contained',
            onClick: SaveAndClose
          }}
        />
         <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={{
            text: 'Annulla',
            type: 'normal',
            stylingMode: 'contained',
            onClick: hide
          }}
        />
       
        <PuntoDiRaccoltaEditPanel ref={puntoDiRaccoltaEditPanelRef} puntoDiRaccoltaId={state.puntoDiRaccoltaId}  />
      </Popup>
      }
    </React.Fragment>
  );
}

export default React.forwardRef(PuntoDiRaccoltaEditPopup);
